import React from "react";
import { Component } from "react";
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import TestLoanCloneCreateModalUI from './TestLoanCloneCreateModalUI.js'

class TestLoanCloneCreateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            accountSubmitted: false,
            //
            accountId: '',
            accountIdError: null,
        }
    }

    render() {
        return (
            <TestLoanCloneCreateModalUI
                context={this.props.context}
                successMsg={this.state.successMsg}
                errorList={this.state.errorList}
                accountList={this.props.accountList}
                accountSubmitted={this.state.accountSubmitted}
                updateMode={this.props.updateMode}
                onRefreshClick={this.props.onRefreshClick}
                onCancelClick={this.props.onCancelClick}
                onSubmit={this.onSubmit}
                //
                accountId={this.state.accountId}
                onAccountIdChange={(event) => { this.setState({ accountId: event.target.value }) }}
                accountIdError={this.state.accountIdError}
                setAccountIdError={(error) => { this.setState({ accountIdError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        if (this.state.accountSubmitted) return

        this.setState({
            successMsg: null,
            errorList: [],
            accountSubmitted: true
        })
        RestApiUtils.post(this.props.context,
            `/api/su/test/loans/${this.props.selectedLoanId}/clone`,
            this.onSubmitCallback, {
            accountId: this.state.accountId
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            accountSubmitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null,
                    updateMode: false
                })
                this.props.onRefreshClick()
            }, 2000)
        }
    }
}

export default withRouter(TestLoanCloneCreateModalSF)